import superagent from 'superagent'

export const locationSharingSet = payload => ({
  type: 'LOCATION_SHARING_SET',
  payload: payload
})

export const locationSharingCreate = payload => ({
  type: 'LOCATION_SHARING_CREATE',
  payload: payload
})

export const locationSharingDelete = payload => ({
  type: 'LOCATION_SHARING_DELETE',
  payload: payload
})

export const shareLocation = bool => ({
  type: 'SHARE_LOCATION',
  payload: bool
})

export const currentLocation = payload => ({
  type: 'CURRENT_LOCATION',
  payload: payload
})

export const shareLocationRequest = (lat, long) => (dispatch, getState, token) => {
  const payload = {
    latitude: lat,
    longitude: long
  }
  return new Promise(resolve => {
    if (token) {
      superagent
        .post(`${__API_URI__}/location/share`)
        .set('Content-Type', 'application/json')
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(JSON.stringify(payload))
        .end((err, res) => {
          if (err) {
            return resolve(err.status)
          }
          dispatch(currentLocation(payload))
          resolve(res)
        })
    } else {
      resolve()
    }
  })
}

export const addShareLocation = friendId => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/location/addShare?friendId=${friendId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          resolve(res.body)
        }
      })
  })
}

export const removeShareLocation = friendId => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/location/removeShare?friendId=${friendId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          resolve(res.body)
        }
      })
  })
}
